import { Injectable } from '@angular/core';
import { OfflineData } from '../models/localstoarge.model';
import { forkJoin, Observable } from 'rxjs';
import { ApiService } from './api.service';
import { map } from 'rxjs/operators';

@Injectable()
export class LocalStorageService {
    constructor(private apiService: ApiService) { }

    public getSearchData(): Promise<OfflineData> {
        return new Promise<OfflineData>((resolve, reject) => {
            if (localStorage.getItem('OfflineData') == undefined) {
                this.saveData().subscribe(res => {
                    resolve(JSON.parse(localStorage.getItem('OfflineData')));
                }, error => {
                    reject(error);
                });
            } else {
                resolve(JSON.parse(localStorage.getItem('OfflineData')));
            }
        });
    }

    public saveData(): Observable<any> {
        return forkJoin([
            this.apiService.getBodyTypes(),
            this.apiService.getTransmissionTypes(),
            this.apiService.getTransmissionTypes(25, 1, JSON.stringify([{ field: 'sequence', direction: 'ASC' }]), null, null, null, '["transmissionType"]'),
            this.apiService.getVehicleTypes(),
            this.apiService.getColorTypes(),
            this.apiService.getUsedAsTypes(),
            this.apiService.getAircoStatusTypes(),
            this.apiService.getConditionTypes(100, 1, JSON.stringify([{ field: 'sequence', direction: 'ASC' }])),
            this.apiService.getCountryOfOriginTypes(100, 1, JSON.stringify([{ field: 'descriptionNl', direction: 'ASC' }])),
            this.apiService.getDriveTypes(100, 1, JSON.stringify([{ field: 'descriptionNl', direction: 'ASC' }])),
            this.apiService.getInteriorTouchTypes(100, 1, JSON.stringify([{ field: 'descriptionNl', direction: 'ASC' }])),
            this.apiService.getLacTypes(100, 1, JSON.stringify([{ field: 'descriptionNl', direction: 'ASC' }])),
            this.apiService.getLiningTypes(100, 1, JSON.stringify([{ field: 'descriptionNl', direction: 'ASC' }])),
            this.apiService.getInteriorColorTypes(100, 1, JSON.stringify([{ field: 'descriptionNl', direction: 'ASC' }])),
            this.apiService.getMaintenanceGuideTypes(),
            this.apiService.getMileageHistoryStatusTypes(),
            this.apiService.getTiresTypes(100, 1, JSON.stringify([{ field: 'sequence', direction: 'ASC' }])),
            this.apiService.getExtraTiresTypes(100, 1, JSON.stringify([{ field: 'sequence', direction: 'ASC' }])),
            this.apiService.getEmployees(50, 1, null, null, JSON.stringify(['Person', 'Function']), null),
        ]).pipe(
            map((data: any[]) => {
                const resData = {
                    synced: true,
                    syncDate: String(new Date()),
                    BodyTypes: (data[0]['data']),
                    TransmissionTypesAutomatic: (data[1]['data']),
                    TransmissionTypesGroups: (data[2]['data']),
                    VehicleTypes: (data[3]['data']),
                    ColorTypes: (data[4]['data']),
                    UsedAsTypes: (data[5]['data']),
                    AircoStatusTypes: (data[6]['data']),
                    ConditionTypes: (data[7]['data']),
                    CountryOfOriginTypes: (data[8]['data']),
                    DriveTypes: (data[9]['data']),
                    InteriorTouchTypes: (data[10]['data']),
                    LacTypes: (data[11]['data']),
                    LiningTypes: (data[12]['data']),
                    InteriorColorTypes: (data[13]['data']),
                    MaintenanceGuideTypes: (data[14]['data']),
                    MileageHistoryStatusTypes: (data[15]['data']),
                    TiresTypes: (data[16]['data']),
                    ExtraTiresTypes: (data[17]['data']),
                    Employees: (data[18]['data'])
                };
                localStorage.setItem('OfflineData', JSON.stringify(resData));
                return resData;
            })
        );
    }
}